import React from "react";

import { TabsContext, TabEnum } from "./TabsContext";

interface Props {
  children: React.ReactNode;
}

export const TabsProvider = (props: Props) => {
  const [currentTab, setCurrentTab] = React.useState<TabEnum>(TabEnum.Home);

  const contextValue = React.useMemo(
    () => ({
      currentTab,
      setCurrentTab,
    }),
    [currentTab, setCurrentTab]
  );

  return (
    <TabsContext.Provider value={contextValue}>
      {props.children}
    </TabsContext.Provider>
  );
};
